import { render, staticRenderFns } from "./deteSelect.vue?vue&type=template&id=07021f5d&scoped=true&"
import script from "./deteSelect.vue?vue&type=script&lang=js&"
export * from "./deteSelect.vue?vue&type=script&lang=js&"
import style0 from "./deteSelect.vue?vue&type=style&index=0&id=07021f5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07021f5d",
  null
  
)

export default component.exports